module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tp"
  }, [_vm._v("Sharon Sala")]), _vm._v(" "), _c('h1', {
    staticClass: "tp1"
  }, [_vm._v("Suspense Stories")]), _vm._v(" "), _c('p', {
    staticClass: "tp"
  }, [_c('em', [_vm._v("Butterfly"), _c('br'), _vm._v("Bloodlines"), _c('br'), _vm._v("Mimosa Grove")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tp1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.png"
    }
  }), _c('br'), _vm._v("New York, 2018")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96bc2572","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/maintp.vue
// module id = 60
// module chunks = 0